import React, { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../../components/ui/tabs/Tabs";
import { cn } from "../../../lib/utils";

export interface WorkbenchTab {
  key: string;
  label: string;
  content: React.ReactNode;
  contentClassName?: string;
}

interface WorkbenchTabsProps {
  tabs: WorkbenchTab[];
  defaultTabKey?: string;
  contentCardClassName?: string;
  contentWrapperClassName?: string;
}

const WorkbenchTabs: React.FC<WorkbenchTabsProps> = ({
  tabs,
  defaultTabKey,
  contentCardClassName,
  contentWrapperClassName,
}) => {
  const [activeKey, setActiveKey] = useState(
    () => defaultTabKey ?? tabs[0]?.key,
  );

  if (tabs.length === 0) return null;

  const renderContent = (tab: WorkbenchTab) => {
    const content = (
      <div className={cn(contentWrapperClassName, tab.contentClassName)}>
        {tab.content}
      </div>
    );

    if (!contentCardClassName) {
      return content;
    }

    return (
      <div className={contentCardClassName}>
        {content}
      </div>
    );
  };

  if (tabs.length === 1) {
    const only = tabs[0];
    return renderContent(only);
  }

  return (
    <Tabs value={activeKey} onValueChange={setActiveKey}>
      <TabsList className="w-full sticky top-0 z-10 overflow-x-auto backdrop-blur-xl bg-[#F9FAFB] justify-start rounded-none p-0 border-b border-[#E5E5E5]">
        {tabs.map((tab) => (
          <TabsTrigger
            key={tab.key}
            value={tab.key}
            className={cn(
              "text-sm font-normal whitespace-nowrap",
              "text-[#0A0A0A] opacity-50",
              "data-[state=active]:opacity-100",
              "data-[state=active]:text-[#0A0A0A]",
              "data-[state=active]:bg-transparent",
              "data-[state=active]:shadow-none",
              "data-[state=active]:after:bg-[#3B82F6]",
              "px-4",
            )}
          >
            {tab.label}
          </TabsTrigger>
        ))}
      </TabsList>

      {tabs.map((tab) => (
        <TabsContent key={tab.key} value={tab.key} className="mt-0">
          {renderContent(tab)}
        </TabsContent>
      ))}
    </Tabs>
  );
};

export default WorkbenchTabs;
